import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useContext } from "react";
import { GRNContext } from "../Context/GRNContext";
import {
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";

import DashboardIcon from "@mui/icons-material/Dashboard";
import DescriptionIcon from "@mui/icons-material/Description";
import ListAltIcon from "@mui/icons-material/ListAlt";
import ScheduleIcon from "@mui/icons-material/Schedule";

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const { user } = useContext(GRNContext);

  const menu = [
    { label: "Dashboard", path: "/dashboard", icon: <DashboardIcon /> },
    ...(user?.role === "admin" || user?.role === "superadmin"
    ? [{ label: "GRN Form", path: "/form", icon: <DescriptionIcon /> }]
    : []),
    // { label: "GRN Form", path: "/form", icon: <DescriptionIcon /> },
    { label: "GRN Records", path: "/records", icon: <ListAltIcon /> },
    { label: "Scheduled Reminders", path: "/scheduled-reminders", icon: <ScheduleIcon /> },
  ];

  return (
    <Box
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      sx={{
        width: open ? 250 : 70,
        transition: "width 0.3s ease",
        height: "100vh",
        backgroundColor: "background.paper",
        borderRight: "1px solid",
        borderColor: "divider",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        p: 1,
      }}
    >
      <List sx={{ mt: 2 }}>
        {menu.map((item) => {
          const isActive = location.pathname === item.path;

          return (
            <Tooltip
              key={item.path}
              title={!open ? item.label : ""}
              placement="right"
            >
              <ListItemButton
                onClick={() => navigate(item.path)}
                selected={isActive}
                sx={{
                  borderRadius: "10px",
                  mb: 1,
                  justifyContent: open ? "initial" : "center",
                  px: 2,
                  backgroundColor: isActive ? "#75bfb0" : "transparent",
                  color: isActive ? "black" : "text.primary",

                  "&:hover": {
                    backgroundColor: "#75bfb0",
                    color: "black",
                  },
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 2 : 0,
                    justifyContent: "center",
                    color: isActive ? "fff" : "text.secondary",
                    transition: "color 0.2s ease"
                  }}
                >
                  {item.icon}
                </ListItemIcon>

                {open && (
                  <ListItemText
                    primary={item.label}
                    sx={{
                      opacity: open ? 1 : 0,
                    }}
                  />
                )}
              </ListItemButton>
            </Tooltip>
          );
        })}
      </List>
    </Box>
  );
}